import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { parseDataModel } from './data/loadDataModel';
import { DataLoadErrorScreen } from './app/DataLoadErrorScreen';
import { AppProviders } from './app/AppProviders';
import { initPosthog } from './utils/posthogClient';
import './styles/tokens.css';
import './styles/global.css';
import './styles/components.css';
import './styles/print.css';

// Fire-and-forget: initPosthog() löst mit `null` auf, wenn die Env-Vars fehlen (Standardfall).
void initPosthog();

const container = document.getElementById('root');
if (!container) {
  throw new Error('Root-Element #root wurde nicht gefunden.');
}

const root = createRoot(container);

// DAT-002: Datenmodell muss vor dem Start der App validiert werden. Bei einem Fehler darf der
// Test nicht starten und es erscheint eine sachliche Fehlerseite statt eines Stacktraces.
const { data, errors } = parseDataModel();

if (!data) {
  root.render(
    <StrictMode>
      <DataLoadErrorScreen errors={errors} />
    </StrictMode>,
  );
} else {
  root.render(
    <StrictMode>
      <AppProviders />
    </StrictMode>,
  );
}
